import { useCallback } from "react";
import {
  findPortfolioByCode,
  searchPortfolios,
} from "@/store/portfoliosStoreACTIONS";
import { returnReferenceDataOptions } from "../helper/ticketSharedHelper";
import ReferenceDataSelect from "./ReferenceDataSelect";

// The portfolio typeahead every ticket uses, and later the Trade Creation allocations.
interface IPortfolioSelect {
  testId: string;
  portfolioCode: string;
  onChange: (portfolioCode: string) => void;
}

const PortfolioSelect = ({
  testId,
  portfolioCode,
  onChange,
}: IPortfolioSelect) => {
  const portfolio = findPortfolioByCode(portfolioCode);

  const searchPortfolioOptions = useCallback(
    (term: string, limit: number) =>
      returnReferenceDataOptions(searchPortfolios(term, limit), (row) => ({
        label: `${row.portfolioCode} - ${row.portfolioName}`,
        value: row.portfolioCode,
      })),
    [],
  );

  return (
    <ReferenceDataSelect
      testId={testId}
      placeholder="Search portfolio ..."
      selected={
        portfolioCode
          ? {
              label: portfolio
                ? `${portfolio.portfolioCode} - ${portfolio.portfolioName}`
                : portfolioCode,
              value: portfolioCode,
            }
          : null
      }
      searchOptions={searchPortfolioOptions}
      onSelect={(option) => onChange(option?.value ?? "")}
    />
  );
};

export default PortfolioSelect;
